/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import PbxMonitor from '../views/PbxMonitor.vue'
import NotFound from '../views/NotFound.vue'
import Redirect from '../views/Redirect.vue'
import Manage from '../views/Manage.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/PbxMonitor',
    name: 'PbxMonitor',
    component: PbxMonitor
  },
  {
    path: '/Manage',
    name: 'Manage',
    component: Manage
  },
  {
    path: '/Redirect',
    name: 'Redirect',
    component: Redirect
  },
  {
    path: '/*',
    name: 'NotFound',
    component: NotFound
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
/* eslint-enable */